"use client";

import Link from "next/link";
import React from "react";
import { useSelector } from "react-redux";

import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";
import withApplication from "@/components/with-application";
import withBrand from "@/components/with-brand";
import { RenewalPage } from "@/config/app-constant";
import { RootState } from "@/store/root-reducer";
import { LoginButtonSectionProps } from "@/types/confirmation-types";

import Styles from "./confirmation-section.module.css";
import Logo from "../logo-component/logo";

function LoginButtonSection({
  aboutCoverTitle,
  aboutCoverContent,
  aboutCoverBtnLabel,
  aboutCoverBtnLink,
  brand,
  application,
}: Readonly<LoginButtonSectionProps & { application?: string }>) {
  const { attributes } = useSelector((state: RootState) => state.quote);
  const { current } = useWizard();

  if (!attributes) return <div>Loading...</div>;

  return (
    <div
      className={`flex flex-col ${brand} ${Styles.login_banner_styles}`}
      data-testid="loginBtnSection-testid"
    >
      <div className={` ${brand} ${Styles.login_banner}`}>
        <div className="lg:flex lg:flex-col lg:gap-spacing-m hidden ">
          <Logo color="white" size="xl" className="lg:!p-0 lg:m-0" />
          <h1 className=" font-header-font text-[26px] md:text-[39px] leading-[27.6px] md:leading-[44.85px] text-center md:text-left md:px-[32.5px] text-dark-text-title lg:py-0 lg:px-0 lg:mb-spacing-l">
            {attributes?.organiser?.firstName &&
              `${aboutCoverTitle}, ${attributes?.organiser?.firstName} `}
            <br />
          </h1>
        </div>
      </div>

      <div
        className={`${Styles.cover_content} ${brand} text-xs leading-[27px]`}
      >
        <RichText richText={aboutCoverContent ?? ""} />
      </div>
      <div className=" lg:flex lg:justify-center md:justify-normal">
        {aboutCoverBtnLink && current.uiElementControls?.showMyAccount && (
          <Link
            href={process.env.NEXT_PUBLIC_MY_ACCOUNT_URL ?? aboutCoverBtnLink}
            target={application === RenewalPage ? "" : "_blank"}
            className="w-full"
          >
            <LabelButtonWrapper
              data-testid="about-cover-button"
              id="about-cover-button"
              isDisabled={false}
              label={aboutCoverBtnLabel ?? ""}
              hierarchy="primary"
              className="md:max-w-xs"
              type="button"
              isLeftIcon={false}
            />
          </Link>
        )}
      </div>
    </div>
  );
}

export default withApplication(withBrand(LoginButtonSection));
